import { render, staticRenderFns } from "./svg-royaume-container.vue?vue&type=template&id=78fe228b&"
import script from "./svg-royaume-container.vue?vue&type=script&lang=js&"
export * from "./svg-royaume-container.vue?vue&type=script&lang=js&"
import style0 from "./svg-royaume-container.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports